import React from 'react';
// import img from '../assets/istockphoto-645632002-612x612.jpg';
import img from '../assets/dpp.jpeg.jpg';
import Button from './shared/Button';
import { FaGithub, FaLinkedin } from "react-icons/fa";


const Header = ({ onMouseEnter, onMouseLeave }) => {
  return (
  <div className='mx-12 mb-10 sm:mb-0'>
  <div className='hidden sm:flex justify-center'>
    <Button onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
      icon={<FaGithub size={28} />}
      color="bg-gray-800"
      url="https://github.com/Bhushan-04"
    />
  </div>
  <div className='flex justify-between mt-10 sm:w-4/5 sm:mx-auto'>
    <Button imagesrc={img} color="bg-transparent" altText="Custom Button Image" />
    {/* <img src={img} height={56} width={56} alt='profile_pic' className='rounded-full aspect-square object-cover cursor-pointer'/> */}
    <button>- Available For Work</button>
  </div>  
  <div className='hidden sm:flex justify-end sm:pl-5'>
    <Button
      icon={<FaLinkedin size={28} />}
      color="bg-blue-800"
      url="https://www.linkedin.com/in/bhushan-pilare-4a7713154/"
    />
  </div>
</div>
  )
}

export default Header;